export default "__VITE_ASSET__BDCYKAqZ__"